var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-12',{staticClass:"item-container"},[_c('div',{staticClass:"item-title"},[_vm._v("危废类别TOP 5")]),_c('dv-scroll-ranking-board',{attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }